import { EChartsCoreOption } from 'echarts';
import {
  ChartDataResponseResult,
  ChartProps,
  DataRecordValue,
  QueryFormColumn,
  QueryFormData,
  QueryFormMetric,
  SetDataMaskHook,
} from '@superset-ui/core';
import {
  DEFAULT_LEGEND_FORM_DATA,
  EchartsLegendFormData,
} from '../../../types';

export type EchartsDoughnutFormData = QueryFormData &
  EchartsLegendFormData & {
    groupby: QueryFormData[];
    metric: QueryFormMetric;
    showLabels: boolean;
    tooltipFormat: string;
};

export interface EchartsDoughnutChartProps
  extends ChartProps<EchartsDoughnutFormData> {
  formData: EchartsDoughnutFormData;
  queriesData: ChartDataResponseResult[];
}

// @ts-ignore
export const DEFAULT_FORM_DATA: EchartsDoughnutFormData = {
  ...DEFAULT_LEGEND_FORM_DATA,
  groupby: [],
  showLabels: true,
  tooltipFormat: '{a} <br/>{b} : {c} ({d}%)',
};

export interface DoughnutChartTransformedProps {
  formData: EchartsDoughnutFormData;
  height: number;
  width: number;
  echartOptions: EChartsCoreOption;
  setDataMask: SetDataMaskHook;
  labelMap: Record<string, DataRecordValue[]>;
  groupby: QueryFormColumn[];
}